import React, { useState, useContext, createContext, useEffect } from "react";
import { CountriesServices } from "../services/CountriesServices";
import { useLanguage } from "./useLanguage";

// ** Utils Imports
const CountriesContext = createContext();

export function ProviderCountries({ children }) {
  const countries = useProviderCountries();
  return (
    <CountriesContext.Provider value={countries}>
      {children}
    </CountriesContext.Provider>
  );
}

export const useCountries = () => {
  return useContext(CountriesContext);
};

function useProviderCountries() {
  const {language} = useLanguage()
  // ** State
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [error, setError] = useState(false);
  const [errorDataCountries, setErrorData] = useState(null);

  // ** Get Countries & Cities
  const getCoutries = () => {
    Promise.all([
      CountriesServices.getAllCountries(),
      CountriesServices.getAllCities()
    ])
      .then(function (results) {
        const resultCountries = results[0];
        const resultCities = results[1];
        Array.isArray(resultCountries.data.data) &&
          setCountries([...resultCountries.data.data]);
        Array.isArray(resultCities.data.data) &&
          setCities([...resultCities.data.data]);
      })
      .catch((errorRes) => {
        setErrorData('')
        setError(true);
      });
  };

  // ** Get Currency From Country
  const getCurrencyByCountryId = (id) => {
   return countries.find((el)=>el.id === id)?.code_currency || "#";
  };

  // ** Countries
  useEffect(() => {
    getCoutries();
    return () => {};
  }, [language]);

  // Return State
  return {
    countries,
    cities,
    error,
    errorDataCountries,
    getCoutries,
    getCurrencyByCountryId
  };
}
